<template>
  <v-container fill-height>
    <v-row align="center" justify="center">
      <h1 class="text-h2 dw_green--text font-weight-thin">Pentesting Playbook</h1>
    </v-row>
    <v-row align="center" justify="center">
      <img src="@/assets/head_logo.png" />
    </v-row>
    <v-row align="center" justify="center">
      <v-btn light outlined color="dw_green" @click="loginWithGoogle">
        <v-icon class="mr-2" v-text="mdiGoogle" />
        <span>Login with Google</span>
      </v-btn>
    </v-row>
    <v-row justify="center" class="my-5">
      <auth-error-alert />
    </v-row>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex';
import { mdiGoogle } from '@mdi/js';
import authErrorAlert from '@/components/notifications/authErrorAlert.vue';

export default {
  name: 'loginForm',
  components: {
    authErrorAlert
  },
  data() {
    return {
      mdiGoogle
    }
  },
  methods: {
    ...mapMutations([
      'throwAuthError'
    ]),
    async loginWithGoogle() {
      try {
        await this.$auth.signIn();
        this.$router.push({ name: 'termsOfUse' });
      } catch {
        this.throwAuthError('Unable to authenticate.');
      }
    }
  }
};
</script>
